export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Cerca',
  catalogHeaderTitle: 'Dettagli',
  catalogDetailsCurtainCopyOptionTitle: 'Copia link',
  catalogDetailsLinkCopiedAlertText: 'Link copiato!',
  catalogDetailsCurtainFlagOptionTitle: 'Segnala contenuto',
  catalogDetailsFlagCurtainTitle: 'Segnala',
  catalogReportedCurtainContent: 'Contenuto segnalato',
  catalogWantBuy: 'Vuoi acquistare {item} da {app}',
  catalogInterestedIn: '{link}'
}
